import React from "react";
import { useParams } from "react-router-dom";
import { Container } from "@mui/material";
import Loading from "../../components/Loading";
import withAuthenticationRequired from "../../components/ProtectedRoutes/withAuthenticationRequired";
import GestionTarifas from "../../components/tarifas/GestionTarifas";
import { PADDING_COMO_HEADER } from "../../components/Header";
import useEventoStore from "../../stores/useEventoStore";
import { ROL } from "../../domain/staff/roles";

export const Tarifas = () => {
  const { id } = useParams();
  const userRole = useEventoStore((state) => state.eventosPorId[id]?.data?.eventoUsuario?.idrol ?? null);

  return (
    <Container className="mt-3 mb-5" sx={PADDING_COMO_HEADER}>
      <GestionTarifas eventoId={id} soloLectura={userRole !== ROL.OWNER} />
    </Container>
  );
};

export default withAuthenticationRequired(Tarifas, {
  onRedirecting: () => <Loading />,
});
